export default {
    path: '/concerns',
    name: 'operations-form',
    component: () => import('source/pages/concerns/ConcernsPortalPage.vue'),
    meta: {
        title: 'Concerns Portal',
        loginRequired: false,
    },
};
